<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header" style="background-color: #be0c4d;">
      <h4 style="color: white;">Tipo Entidad</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-auto">
          <a type="a" class="btn btn-secondary" (click)="Regresar()">Volver</a>
        </div>
        <div class="col-auto">
          <a type="a" class="btn btn-primary" (click)="NuevoTipoEntidad()" style="color: white;">Nuevo</a>
        </div>
      </div>
      <div class="container">
        <form>
          <div class="row justify-content-md-center">
            <div class="col-7">
              <div class="row">
                <div class="col">
                  <div><label><b>Código superintendencia: </b></label></div>
                  <div><select class="form-select" aria-label="Default select example" name="super" [(ngModel)]="NuevaTipoEntSup" [disabled]="!NuevatipoEnt">
                      <option selected value="0">Seleccionar</option>
                      <option *ngFor="let super of Superintendencias" value="{{super.codigo}}">{{super.nombre}}</option>
                    </select></div>
                </div>
                <div class="col">
                  <div><label><b>Código tipo entidad: </b></label></div>
                  <div><input class="form-control" name="codigo" [formControl]="NuevaTipoEntCod"></div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div><label><b>Nombre tipo entidad: </b></label></div>
                  <div><input class="form-control" name="nombre" [formControl]="NuevaTipoEntNom"></div>
                </div>
              </div>
              <br>
              <div class="row justify-content-md-center">
                <button type="button" class="btn btn-primary col-2" (click)="Guardar()" [disabled]="!NuevatipoEnt||NuevaTipoEntCod.hasError('required')||NuevaTipoEntNom.hasError('required')">Guardar</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <br>
      <div class="container-fluid overflow-scroll" style="align-content: center;">
        <table class="table table-bordered">
          <thead>
            <th>Superintendencia</th>
            <th>Codigo</th>
            <th>Nombre</th>
            <th>Editar</th>
          </thead>
          <tbody>
            <tr *ngFor="let t of TipoEntList | paginate:{ itemsPerPage: 5, currentPage: page }">
              <td>{{t.idSuper}}</td>
              <td>{{t.codigo}}</td>
              <td>{{t.nombre}}</td>
              <td style="text-align: center;"><a type="button" class="fa fa-edit" data-toggle="modal" data-target="#modalEditar"
                data-bs-toggle="tooltip" data-bs-placement="right" title="editar de superintendencia"
                (click)="editarSuper(t)" style="color: green;"></a></td>
            </tr>
          </tbody>
        </table>
        <div class="row justify-content-center">
          <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
        </div>
      </div>
    </div>
  </div>
</body>

<div class="modal fade bd-example-modal-lg" id="modalEditar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modalEditar" style="color: white;">Editar Tipo Entidad</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <form>
            <div class="col-9" style="margin: auto;">
              <div class="row">
                <div class="col">
                  <div><label><b>Código tipo entidad: </b></label></div>
                  <div><input class="form-control" name="super" [(ngModel)]="TipoEntEditar.codigo"></div>
                </div>
                <div class="col">
                  <div><label><b>Código superintendencia: </b></label></div>
                  <div><input class="form-control" name="codigo" [(ngModel)]="TipoEntEditar.idSuper"></div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div><label><b>Nombre tipo entidad: </b></label></div>
                  <div><input class="form-control" name="nombre" [(ngModel)]="TipoEntEditar.nombre"></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" style="background-color: #be0c4d;" (click)="guardarSuperEditada()">Guardar</button>
      </div>
    </div>
  </div>
</div>
